import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SearchPipe } from "./search.pipe";
import { ImpureSearchPipe } from "./impure-search.pipe";
import { TranslatedNamePipe } from "./translated-name-pipe.pipe";
import { FilterPipe } from "./filter.pipe";
import { RheroBusinessPipe } from "./rhero-business.pipe";

@NgModule({
  declarations: [SearchPipe, ImpureSearchPipe, TranslatedNamePipe, FilterPipe, RheroBusinessPipe],
  imports: [CommonModule],
  exports: [SearchPipe, ImpureSearchPipe, TranslatedNamePipe, FilterPipe, RheroBusinessPipe]
})
export class PipesModule {}
